import React from 'react';

const InrFees = () => (
	<section>
		<div>
			<h2 className="text-xl font-bold my-4">INR’ Deposit Fees</h2>
			<p className="u-para--readable mb-6">Deposits are totally free.</p>
			<ul className="list-disc pl-8">
				<li className="pb-2">
					UPI deposit fee: <b>0%</b>
				</li>
				<li className="pb-2">
					Bank deposit fee: <b>0%</b>
				</li>
				<li className="pb-2">
					Peer-to-peer USDT deposit: <b>0%</b>
				</li>
			</ul>
		</div>
		<div>
			<h2 className="text-xl font-bold mt-24 mb-4">
				INR’ Withdrawal Fees
			</h2>
			<p className="u-para--readable mb-6">
				INR’ withdrawals are free, except Instant Withdrawals which are
				charged upto ₹9 only.
			</p>
			<div className="c-table__scrollWrapper mb-4 max-w-2xl">
				<table className="c-table border-gray-200 text-left w-full">
					<thead>
						<tr className="border-b border-gray-200">
							<th
								width="50%"
								className="py-8 px-4 md:px-8 align-top font-normal text-gray-800 text-sm"
							>
								Type
							</th>
							<th className="py-8 px-4 md:px-8 align-top font-normal text-gray-800 text-sm">
								Fee
							</th>
						</tr>
					</thead>
					<tbody>
						<tr className="border-b border-gray-200">
							<td className="py-8 px-4 md:px-8">
								Normal Withdrawals
							</td>
							<td className="py-8 px-4 md:px-8">0%</td>
						</tr>
						<tr className="border-b border-gray-200">
							<td className="py-8 px-4 md:px-8">
								P2P USDT Withdrawals
							</td>
							<td className="py-8 px-4 md:px-8">0%</td>
						</tr>
						<tr className="border-b border-gray-200">
							<td className="py-8 px-4 md:px-8">
								Instant Withdrawals
							</td>
							<td className="py-8 px-4 md:px-8">
								&lt; ₹1000: <b>₹4</b>
								<br />
								₹1000 - 24,999: <b>₹6</b>
								<br />
								₹25,000 and above: <b>₹9</b>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<p className="u-para--readable mb-6">
				Instant withdrawal charges can be reduced with Pay with BNS
				turned on.
			</p>
			<div className="c-table__scrollWrapper mb-4 max-w-2xl">
				<table className="c-table border-gray-200 text-left w-full">
					<thead>
						<tr className="border-b border-gray-200">
							<th
								width="50%"
								className="py-8 px-4 md:px-8 align-top font-normal text-gray-800 text-sm"
							>
								BNS holding Worth
							</th>
							<th className="py-8 px-4 md:px-8 align-top font-normal text-gray-800 text-sm">
								Discount on withdrawals with{' '}
								<b>Pay with BNS turned on </b>
							</th>
						</tr>
					</thead>
					<tbody>
						<tr className="border-b border-gray-200">
							<td className="py-8 px-4 md:px-8">&gt;= 50 USD</td>
							<td className="py-8 px-4 md:px-8">10%</td>
						</tr>
						<tr className="border-b border-gray-200">
							<td className="py-8 px-4 md:px-8">&gt;= 100 USD</td>
							<td className="py-8 px-4 md:px-8">30%</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</section>
);

export default InrFees;
